import api from '~/services/api';
import errorHandler from '~/Utils/errorHandler';

const endPoint = 'api/quickbooks';

// CashFlow
export const cashFlow = async params => {
  const endPointComplement = 'cashflow';
  try {
    const { data } = await api.post(`/${endPoint}/${endPointComplement}`, params);
    return data;
  } catch (error) {
    errorHandler(error);
    return { Rows: { Row: [] } };
  }
};

// ProfitAndLoss
export const profitAndLoss = async params => {
  const endPointComplement = 'profitandloss';
  try {
    const { data } = await api.post(`/${endPoint}/${endPointComplement}`, params);
    return data;
  } catch (error) {
    errorHandler(error);
    return { Rows: { Row: [] } };
  }
};

// ProfitAndLossDetail
export const profitAndLossDetail = async params => {
  const endPointComplement = 'profitandlossdetail';
  try {
    const { data } = await api.post(`/${endPoint}/${endPointComplement}`, params);
    return data;
  } catch (error) {
    errorHandler(error);
    return { Rows: { Row: [] } };
  }
};

// Get Customer from Quickbooks
export const getCustomerQb = async params => {
  const endPointComplement = 'customer';
  try {
    const { data } = await api.get(`/${endPoint}/${endPointComplement}`, { params });
    return data;
  } catch (error) {
    errorHandler(error);
    return { QueryResponse: { Customer: [] } };
  }
};

// Insert Customer in Quickbooks
export const customerCreateQb = async params => {
  const endPointComplement = 'customerCreate';
  try {
    const { data } = await api.post(`/${endPoint}/${endPointComplement}`, params);
    return data;
  } catch (error) {
    errorHandler(error);
    return { QueryResponse: { Customer: [] } };
  }
};
